import { ApiConfig } from 'src/plugins/api/declare'

const apiConfig: ApiConfig[] = [
  {
    name: 'getEquipmentTypeIndustry',
    method: 'POST',
    path: '/OP/OPEquipmentType/GetEquipmentTypeIndustry',
    params: {},
    axiosOptions: {},
    desc: '设备类型库-行业类型'
  },
  {
    name: 'update',
    method: 'POST',
    path: '/OP/OPEquipmentType/IndustryFullUpdate',
    params: {
      ID: undefined,
      CODE: '',
      NAME: '',
      ORG_ID: '',
      INDUSTRY_TYPE: 2
    },
    axiosOptions: {},
    desc: '设备类型库-新增编辑行业'
  },
  {
    name: 'delete',
    method: 'GET',
    path: '/OP/Industry/Delete',
    params: {
      ID: ''
    },
    axiosOptions: {},
    desc: '设备类型库-删除行业'
  },
]

export default apiConfig